

define(['angular', 'text!./template.html'], function (angular, template) {
    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', [function () {
        return {
            template: template,
            scope: {
                token: '=?',
                track: '@?',
                onClick: '=?',
                buttonText: '@?',
                isProcessing: '=?',
                validate: '=?'
            },
            controller: ['$scope', function ($scope) {

                $scope.submit = function () {
                    if ($scope.onClick) {
                        $scope.onClick();
                    } else {
                        $scope.validate = true;
                    }
                };
            }]
        };
    }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/spinner-button/directive.js
// module id = ../node_modules/xo-ui-components/src/spinner-button/directive.js
// module chunks = 0